export const ADD_PRODUCT = "ADD_PRODUCT";
export const CHANGE_AMOUNT_PRODUCT = "CHANGE_AMOUNT_PRODUCT";
export const CART_TOTAL = "CART_TOTAL";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const CART_RESET = "CART_RESET";

export const FORM_CHECKBOX = "FORM_CHECKBOX";
export const ON_SUBMIT_FORM = "ON_SUBMIT_FORM";
export const ADD_FORM_VALUES = "ADD_FORM_VALUES";

export const SET_DELIVERY_PAYMENT_VALUES = "SET_DELIVERY_PAYMENT_VALUES";
export const SET_POINT = "SET_POINT";
export const ORDER_TOTAL = "ORDER_TOTAL";
